import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { client } from "../../helpers/api/apiCall";

const initialState = {
  ayetler: {
    items: [],
    index: 0,
    size: 10,
    count: 0,
    pages: 0,
    hasPrevious: false,
    hasNext: false,
  },
  loading: true,
};

export const getAyetler = createAsyncThunk("getAyetler", async (body) => {
  const response = await client.post("https://servis.kuranhayatim.com/api/Ayet/GetList",body);
  return response.data;
});

export const insertAyet = createAsyncThunk("insertAyet", async (body,thunkAPI) => {
  const response = await client.post("https://servis.kuranhayatim.com/api/Ayet",body,{
    token: thunkAPI.getState().auth.accessToken.token
  });
  return response.data;
});

export const updateAyet = createAsyncThunk("updateAyet", async (body,thunkAPI) => {
  const response = await client.put("https://servis.kuranhayatim.com/api/Ayet/",body,{
    token: thunkAPI.getState().auth.accessToken.token
  });
  return response.data;
});

export const deleteAyet = createAsyncThunk("deleteAyet", async (body,thunkAPI) => {
    const response = await client.delete("https://servis.kuranhayatim.com/api/Ayet/",body,{
      token: thunkAPI.getState().auth.accessToken.token
    });
    return response.data;
  });

const ayetSlice = createSlice({
  name: "ayet",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getAyetler.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getAyetler.fulfilled, (state, action) => {
      state.ayetler = action.payload;
      state.loading = false;
    });
    builder.addCase(getAyetler.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(insertAyet.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(insertAyet.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(insertAyet.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(updateAyet.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(updateAyet.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(updateAyet.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(deleteAyet.pending, (state, action) => {
        state.loading = true;
      });
      builder.addCase(deleteAyet.fulfilled, (state, action) => {
        state.loading = false;
      });
      builder.addCase(deleteAyet.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default ayetSlice.reducer;
